<template>
  <section class="dashboard box p-5">
    <h1 class="title is-4 mb-4">📊 Resumen general</h1>

    <!-- MÉTRICAS -->
    <div class="columns is-multiline">
      <div class="column is-one-third">
        <b-notification type="is-info" class="has-text-centered">
          <p class="title is-5">📤 Enviados</p>
          <p class="is-size-3 has-text-weight-bold">{{ totalEnviados }}</p>
        </b-notification>
      </div>

      <div class="column is-one-third">
        <b-notification type="is-success" class="has-text-centered">
          <p class="title is-5">✅ Confirmados</p>
          <p class="is-size-3 has-text-weight-bold">{{ totalConfirmados }}</p>
        </b-notification>
      </div>

      <div class="column is-one-third">
        <b-notification
          type="is-warning"
          @click="verDetalle('pendiente')"
          class="has-text-centered is-clickable"
        >
          <p class="title is-5">🕓 Pendientes</p>
          <p class="is-size-3 has-text-weight-bold">{{ totalPendientes }}</p>
        </b-notification>
      </div>

      <div class="column is-one-third">
        <b-notification
          type="is-danger"
          @click="verDetalle('error')"
          class="has-text-centered is-clickable"
        >
          <p class="title is-5">❌ Errores</p>
          <p class="is-size-3 has-text-weight-bold">{{ totalErrores }}</p>
        </b-notification>
      </div>

      <!-- <div class="column is-one-third">
          <b-notification type="is-dark" class="has-text-centered">
            <p class="title is-5">💬 No confirmados</p>
            <p class="is-size-3 has-text-weight-bold">{{ totalNoConfirmados }}</p>
          </b-notification>
        </div> -->

      <div class="column is-one-third">
        <b-notification type="is-primary" class="has-text-centered">
          <p class="title is-5">💰 Saldo consumido</p>
          <p class="is-size-3 has-text-weight-bold">
            ${{ saldoConsumido.toLocaleString() }} COP
          </p>
        </b-notification>
      </div>
    </div>

    <!-- GRÁFICO DE CATEGORÍAS -->
    <div class="box mt-4">
      <h2 class="title is-5">Envíos por categoría</h2>
      <canvas ref="graficoCategoria" height="150"></canvas>
    </div>
    <b-modal :active.sync="modalActivo" has-modal-card trap-focus scroll="keep">
      <modal-mensajes
        :mensajes="mensajesModal"
        :estado="estadoModal"
        @cerrar="modalActivo = false"
      />
    </b-modal>
  </section>
</template>
  
  <script>
import Chart from "chart.js";
import HttpService from "@/Servicios/HttpService";
import ModalMensajes from "../Extras/ModalMensajes.vue";

export default {
  components: {
    ModalMensajes,
  },
  name: "DashboardComponent",
  data() {
    return {
      totalEnviados: 0,
      totalConfirmados: 0,
      totalPendientes: 0,
      totalErrores: 0,
      totalNoConfirmados: 0,
      saldoConsumido: 0,
      categorias: [],
      modalActivo: false,
      mensajesModal: [],
      estadoModal: "",
    };
  },
  mounted() {
    this.obtenerEstadisticas();
  },
  methods: {
    async obtenerEstadisticas() {
      try {
        const data = await HttpService.obtenerConConsultas("dashboard.php", {
          accion: "resumen",
        });

        this.totalEnviados = data.totalEnviados;
        this.totalConfirmados = data.totalConfirmados;
        this.totalPendientes = data.totalPendientes;
        this.totalErrores = data.totalErrores;
        this.totalNoConfirmados = this.totalPendientes + this.totalErrores;
        this.saldoConsumido = this.totalConfirmados * 20;
        this.categorias = data.porCategoria;

        this.graficarPorCategoria();
      } catch (err) {
        console.error("Error al cargar estadísticas", err);
      }
    },

    graficarPorCategoria() {
      const ctx = this.$refs.graficoCategoria.getContext("2d");

      new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: this.categorias.map((c) => c.nombre),
          datasets: [
            {
              label: "Envíos por categoría",
              data: this.categorias.map((c) => c.cantidad),
              backgroundColor: this.categorias.map(
                () => `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`
              ),
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          legend: {
            position: "bottom",
            labels: {
              boxWidth: 12,
            },
          },
        },
      });
    },

    async verDetalle(estado) {
      try {
        const data = await HttpService.obtenerConConsultas("dashboard.php", {
          accion: "mensajes_por_estado",
          estado: estado,
        });

        if (Array.isArray(data) && data.length) {
          this.estadoModal = estado;
          this.mensajesModal = data;
          this.modalActivo = true;
        } else {
          this.$buefy.toast.open("No hay mensajes en este estado.");
        }
      } catch (err) {
        console.error("Error obteniendo mensajes:", err);
      }
    },
  },
};
</script>
  
  <style scoped>
.dashboard {
  max-width: 960px;
  margin: auto;
}
</style>
  